module.exports = __webpack_public_path__ + "static/media/DaysOff4.499414c7.png";